export const RouteLinksData = [
  {
    name: "Become a store owner",
    value: "restaurant_owner",
    link: `${process.env.REACT_APP_BASE_URL}/store/apply`,
  },
  {
    name: "Become a delivery man",
    value: "delivery_man",
    link: `${process.env.REACT_APP_BASE_URL}/deliveryman/apply`,
  },
  {
    name: "Help & Support",
    value: "help-and-support",
    link: "/help-and-support",
  }


];
